// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"549":"0b11a4db","619":"c2b70ca0"}[chunkId] + ".chunk.js";
};